module.exports = "/shared/fonts/proxima-nova-bold.otf";


//////////////////
// WEBPACK FOOTER
// ./src/ui/fonts/proxima-nova-bold.otf
// module id = 17
// module chunks = 13